import React, { useState, useEffect } from 'react';
import Spinner from '../Spinner';
import { useApi } from '../../api/ApiProvider';
import Api from '../../axiosApi/api';
import { useToastMessageQueue } from '../ToastMessages/ToastMessageProvider';
import intl from 'components/i18n/ReactIntlWrapper';
import ItemsSelect from '../ItemsSelect';
import CorporateEntitiesNavbar from './CorporateEntitiesNavbar';
import CorporateEntitiesList from './CorporateEntitiesList';
import CorporateEntitiesPagination from './CorporateEntitiesPagination';
import { handleAPIError } from 'common/errorHandler';
import ErrorSummary from 'components/common/ErrorSummary';

export type CorporateEntitiesInput = {
    queryTerm?: string | null,
    idCountry?: number | null,
    currentPage?: number,
    sortValue?: string | null,
    orderValue?: string| null
};

export type SearchResult = {
	totalRecords: number | null,
	queryResult: any
};

const CorporateEntities = () => {

    const [input, setInput] = useState<CorporateEntitiesInput | null>({
        queryTerm: "",
        idCountry: null,
        currentPage: 1,
		sortValue: "",
		orderValue: "asc",
	});

    const [corporateEntities, setCorporateEntities] = useState<SearchResult | null>({
        totalRecords: null,
        queryResult: null
	});

    const [countries, setCountries] = useState(null);

    const [loading, setLoading] = useState<boolean>(false);

    const [errors, setErrors] = useState({});
    
    const api: Api = useApi();

    const toast = useToastMessageQueue();

    const [pageCount, setpageCount] = useState<number>(0);

    const [limit, setLimit] = useState<number>(() => {
		return parseInt(localStorage.getItem('itemsPerPageCorporateEntities'), 10) || 10;
	});

    useEffect(() => {
		setLimit(parseInt(localStorage.getItem('itemsPerPageCorporateEntities'), 10) || 10);
	}, []);

    const fetchCorporateEntities = async (term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>) => {
        setLoading(true);
        if (input.idCountry) {
            f = [`country:${input.idCountry}`];
        }
        const response = await api.invoiceApi.apiVversionCorporateEntitySearchGet ("1", input.queryTerm, input.currentPage, limit, input.sortValue, input.orderValue, f, {}).then((response) => {
            if (response.data.data.queryResult) {
                setCorporateEntities({
                    totalRecords: response.data?.data?.totalRecords,
                    queryResult: response.data?.data?.queryResult
                });
            } else {
                setCorporateEntities({
                    totalRecords: null,
                    queryResult: null
                });
            };
            console.log("Success");
        }).catch((error) => {
            handleAPIError(error, toast, errors);
            setErrors({ ...errors });
        }).finally(() => {
            setLoading(false);
        })
    };

    const fetchCountries = async () => {
        const response = await api.addressApi.apiVversionAddressCountryAllGet("1", {}).then((response) => {
            if (response.data) {
                setCountries(response.data.data);                
            };
        }).catch((error) => {
            handleAPIError(error, toast, errors);
            setErrors({...errors});
        });
    };

    useEffect(() => {
        fetchCorporateEntities();
        fetchCountries();
	}, [input, limit]);

    const handlePageClick = pageNum => setInput({ ...input, currentPage: pageNum });

	const nextPage = () => setInput({ ...input, currentPage: input.currentPage + 1 });

	const prevPage = () => setInput({ ...input, currentPage: input.currentPage - 1 });

	const initialPage = () => setInput({ ...input, currentPage: 1 });

	const finalPage = () => setInput({ ...input, currentPage: pageCount });

    const onSearch = (queryString, idCountry) => {
        setErrors([]);
		setInput({ ...input, queryTerm: queryString, idCountry: idCountry, currentPage: 1 });
	};

    return (
        <div className="container">
            <div className='card mt-4'>
                <div className="card-header">
                    <h2 className="title">Corporate Entities</h2>
                </div>
                <div className='card-body'>
                    <div>
                        <CorporateEntitiesNavbar
                            onSearch={onSearch}
                            countries={countries}
                        />
                        {
                            loading === true ?
                            <Spinner /> :
                            <>
                                <div className="col-md-12">
                                    <ErrorSummary errors={errors} showEverything={false} mode="warning"></ErrorSummary>
                                </div>
                                <CorporateEntitiesList searchResult={corporateEntities} />
                                <div className="pagination row w-100">
                                    <div className="col-10 col-xl-11 d-flex justify-content-center">
                                        <CorporateEntitiesPagination handlePageClick={handlePageClick} limit={limit} searchResult={corporateEntities} nextPage={nextPage} prevPage={prevPage} input={input} pageCount={pageCount} setpageCount={setpageCount} initialPage={initialPage} finalPage={finalPage} />
                                    </div>
                                    <div className="col-2 col-xl-1 d-flex justify-content-end">
                                        <ItemsSelect 
                                            input={input}
                                            setInput={setInput}
                                            limit={limit} 
                                            setLimit={setLimit} 
                                            storageKey="itemsPerPageCorporateEntities"
                                        />
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CorporateEntities;